module.exports = __webpack_public_path__ + "static/media/fb.c1bd1863.svg";